<template>
  <template-personal
    :pathName="pathName"
    :hasFinalTaxType="hasFinalTaxType"
    :fact="fact"
  >
    <div slot="to-do">
      <div class="contents">
        <span>6. </span>
        <span class="wld-link">
          <span class="bold">เพื่อผลประโยชน์สูงสุดในการดำเนินกิจการ</span>
          เราแนะนำให้ซื้อสินค้ากับผู้ประกอบการจดทะเบียนภาษีมูลค่าเพิ่ม (VAT)
          แล้ว
          <chevron-right-link
            style="margin: 9px 0"
            @clickLink="goToGoodsTax"
            caption="ดูคำอธิบายเพิ่ม"
          />
        </span>
      </div>
    </div>
  </template-personal>
</template>

<script>
export default {
  name: "PersonalRegisteredWithoutVat",
  props: ["hasFinalTaxType"],
  data() {
    return {
      pathName: "personal_registered_without_vat",
      fact: [
        "คุณจะมีค่าใช้จ่ายเพิ่มเติมที่ตามมาหลังจด VAT คือค่าใช้จ่ายในการจัดทำและนำส่ง VAT แต่ละเดือน",
        "การจด VAT ช่วยให้คุณมีหลักฐานในการขอเครดิตจากธนาคารในกรณีที่คุณต้องการเงินทุนเพื่อขยายกิจการในอนาคต",
        "การซื้อสินค้าจากผู้ประกอบการที่ไม่จด VAT ทำให้คุณต้องแบกรับภาระค่าใช้จ่ายทางภาษีเอาไว้เอง เพราะไม่สามารถขอคืนภาษีซื้อได้",
      ],
    };
  },
  methods: {
    goToGoodsTax() {
      this.$router.push({
        path: "/info/goods_tax",
      });
    },
  },
};
</script>

<style scoped></style>
